import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [ready, setReady] = useState(!!location.state?.user);

  useEffect(() => {
    if (location.state?.user) { setReady(true); return; }
    if (loading) return;
    if (!user) { navigate("/command", { replace: true }); return; }
    setReady(true);
  }, [user, loading, navigate, location.state]);

  if (loading || !ready) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#1A2421] text-white">
        <Loader2 size={32} className="animate-spin text-[#62B848]" />
      </div>
    );
  }
  return children;
}
